export function formatDateRange(intlShape, ...[from, to, formatOptions]) {
  return intlShape.formatDateTimeRange(from, to, formatOptions);
}